/**
 * Created by Akihiro-Kato on 2017/03/27.
 */

import React, {Component} from 'react';
import {render} from 'react-dom';
import $ from 'jquery';

import data from './data';

export default class About extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentWillMount(){

    let _this = this;

  }

  componentDidMount(){
    $("html, body").animate({scrollTop: 0}, 1);
  }

  render() {
    return (
      <div className="wrap about" id="top">
        <section className="concept">
          <div className="inner">
            <h2>ABOUT US</h2>
            <h3>Gifu Indie Design Sessions とは</h3>
            <p>GIDSとは、デザインやアート、ITといったクリエイティブな視点から、新しい仕事をうみだしたり、小さな地域経済を整えたりする自由で自主的な互助のつながりです。</p>
            <p><a className="mail" href="http://gids.jp/articles/182">GIDS入会案内</a></p>
            <br/>
            <h4>「鉄腕アトムはもう来ない。」</h4>
            <p>鉄腕アトムが誕生したという未来はあっという間に過去になった。デロリアンは結局2015年にやってこなかったし、パトレイバーも実用化されなかった。僕らが夢見たハイテクと経済成長の未来はどんどん過去になり、新しい未来は空白のままだ。</p>
            <p>鉄腕アトムに待ちぼうけを喰らった僕には、「もののけ姫」のアシタカが男前に見える。自然に帰りすぎたエコロジー過激派のサン（美少女）を口説くために、優男の彼は、「森とタタラ場、双方ともに生きる道はないのか！？」と言う。やっぱり男前は言うことが違うなぁ。</p>
            <p>タタラ場っていうのは、鉄腕アトムのことなんじゃないだろうか。<br />アシタカは、単なる下心でエコに理解を示したのかもしれない。それでも、僕はもうスペアポケット依存症ののび太ではいられない。じゃあ何をするのかって？アラン・ケイ曰く「未来を予測する最善の方法は、それを発明することだ」（文責 中原淳）</p>
          </div>
        </section>
        <section className="system">
          <div className="inner">
            <h2>ORGANIZATION</h2>
            <div className="figure"><img src="/images/about_pct_system.svg" alt="運営図"/></div>
            <p>キュレーション委員会（2021年現在 50音順）</p>
            <p>金子典栄  小池達也  所和徳  中原淳  宮脇志穂  山口歩那  </p>
          </div>
        </section>
        <section className="activity">
          <div className="inner">
            <h2>ACTIVITY</h2>
            <ul>
              <li>
                <div className="head"></div>
                <div className="content">
                  <h3>コワーキングスペースの運営</h3>
                  <p>GIDS会員が自由に利用できる無料のオフィススペースを、自治運営します。またキッチンやギャラリーを使った小商いを行うメンバーも募集します。</p>
                </div>
              </li>
              <li>
                <div className="head"></div>
                <div className="content">
                  <h3>滞在型デザイナー制度の運営</h3>
                  <p>世界各地からクリエーターを招聘して、短期滞在してもらい、地域の資源を活用した新しい仕事をデザインします。</p>
                </div>
              </li>
              <li>
                <div className="head"></div>
                <div className="content">
                  <h3>クリエイティブな起業活動の支援</h3>
                  <p>起業塾の開催や各種イベントを企画します。</p>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <div className="pagetop"><a href="#top"><img src="/images/pagetop.png" alt="pagetop"/></a></div>
      </div>
    )
  }

}




// WEBPACK FOOTER //
// ./src/js/about.js